import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import Model, { onChange as onChangeModel } from '../../lib/Model'

import { Form, Field, Input, Checkbox, Note, Button, Icon } from '../Common'

import style from './Form.scss'

import logoFacebook from '../../images/f_logo_RGB-White_1024.png'

class FormLogin extends Component {
  static propTypes = {
    search: PropTypes.object,
    loading: PropTypes.bool,
    onSubmit: PropTypes.func.isRequired,
  }

  state = {
    form: {
      submitted: false,
      error: false,
      email: new Model('email', this.props.search.email, 'email'),
      password: new Model('password', '', 'password'),
      rememberMe: new Model('rememberMe', true, 'checkbox'),
      /* reCAPTCHAToken: null,
      failedAttempts: 0,
      loginBlocked: false, */
    },
  }

  onChange = (event, model) => {
    this.setState(onChangeModel(model))
  }

  onSubmit = () => {
    if (this.props.loading) {
      return
    }
    const { submitted, email, password, rememberMe/* , reCAPTCHAToken, loginBlocked */ } = this.state.form
    if (submitted === false) {
      this.setState((state) => ({
        ...state,
        form: {
          ...state.form,
          submitted: true,
        },
      }))
    }
    if (email.invalid || password.invalid/*  || loginBlocked */) {
      return
    }
    this.props.onSubmit(
      {
        email: email.value,
        password: password.value,
        rememberMe: rememberMe.checked,
        /* reCAPTCHAToken, */
      },
      (err) => {
        const invalid_login = err && err.response && err.response.data && err.response.data.status == 'invalid_login'
        const invalid_customer = err && err.response && err.response.data && err.response.data.status == 'inactive'
        /* const loginBlocked = err && err.response && err.response.data && err.response.data.status === 'login_blocked' */

        if (err === undefined) return
        this.setState((state) => ({
          ...state,
          form: {
            ...state.form,
            error: invalid_login,
            invalid: invalid_customer,
            /* loginBlocked,
            failedAttempts: state.form.failedAttempts + 1, */
          },
        }))
      },
    )
  }

  /* protectWithReCaptcha = (fn) => {
    if (this.state.form.failedAttempts < 3) {
      return fn()
    }

    grecaptcha.ready(() => grecaptcha.execute(window.RECAPTCHA_SITE_KEY, { action: 'login' })
      .then(reCAPTCHAToken => {
        this.setState((state) => ({ ...state, form: { ...state.form, reCAPTCHAToken } }))
        return fn()
      }))
  } */

  render() {
    const { loading } = this.props
    const { submitted, error, invalid, email, password, rememberMe/* , loginBlocked */ } = this.state.form

    const emailInvalid = submitted && email.untouched && email.invalid
    const passwordInvalid = submitted && password.untouched && password.invalid

    return (
      <Form id="form-login" /* onSubmit={() => this.protectWithReCaptcha(this.onSubmit)} */ onSubmit={() => this.onSubmit()} className={style.form}>
        <Field label="e-mail" className={style.field}>
          <Input
            id="input-email"
            model={email}
            invalid={emailInvalid}
            onChange={this.onChange}
            required
            tabIndex={0}
            autoFocus
          />
          <Note id="email-invalido" error show={emailInvalid}>
            campo obrigatório
          </Note>
        </Field>
        <Field label="senha" className={style.field}>
          <Input
            id="input-senha"
            model={password}
            invalid={passwordInvalid}
            onChange={this.onChange}
            required
            tabIndex={0}
          />
          <Note id="senha-invalida" error show={passwordInvalid}>
            campo obrigatório
          </Note>
        </Field>
        <Checkbox model={rememberMe} onChange={this.onChange} tabIndex={0} id="check-continuar-conectado">
          continuar conectado
        </Checkbox>
        <Button id="submit-entrar" submit disabled={submitted/*  && loginBlocked */} loading={loading} className={style.sigin}>
          entrar
        </Button>
        <Note id="email-senha-invalidos" error show={!loading && submitted && error}>
          e-mail ou senha inválidos
        </Note>
        <Note id="conta-desativada" error show={!loading && submitted && invalid}>
          Sua conta está desativada. Por favor, verifique sua conta.
        </Note>
        <Note id="deseja-supervisor" className={style.note}>
          Se você deseja acessar o Supervisor utilize o mesmo endereço URL anteriormente informado por nossa equipe.
          <br />
          <br />
          Se você deseja acessar o Ticket, <a href="https://agent.directtalk.com.br/">clique aqui</a>
        </Note>
        {/* <Note id="login-bloqueado" error show={!loading && submitted && loginBlocked}>
          Tentativa de login suspeita.
        </Note> */}
        <Button id="button-conn-facebook" href="/facebook_login" theme="blueDark" className={style.facebook}>
          <img src={logoFacebook} alt="logotipo facebook" />
          Fazer login com o Facebook
        </Button>
        <Link
          id="link-esqueci-senha"
          to={{ pathname: '/forgot', search: `?email=${email.value}` }}
          className={style.linkForgot}
        >
          esqueci minha senha <Icon value="keyboard_arrow_right" material />
        </Link>
      </Form>
    )
  }
}

export default FormLogin



// WEBPACK FOOTER //
// ./src/components/Login/Form.js